import services from '../services';

// Company Config (bu-admin) type holding the lists where the trip create / clone icon is shown.
// data.listIds empty or no record = shown in every list.
export const TRIP_BUTTON_CONFIG_TYPE = 'trip-button-lists';

export const getTripButtonConfig = async () => {
    const configs = await services.companyConfig.GET_COMPANY_CONFIGS();
    return configs.find((c) => c.type === TRIP_BUTTON_CONFIG_TYPE) || null;
};

export const isTripButtonAllowedInList = (config, listId) => {
    const ids = config?.data?.listIds;
    if (!config || config.status === false || !Array.isArray(ids) || ids.length === 0) return true;
    return ids.includes(listId);
};
